import React from 'react';
import { DropTarget } from 'react-dnd';
import OneDragPict from '../../components/oneDragPict';
import './style.scss';

const pictTarget = {
  drop(props) {
    props.changePictOrder(props.item);
  },
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  };
}

export const UploaderImage = DropTarget(
  'PICTURE',
  pictTarget,
  collect
)(({ saveCurrentPictOrder, i, connectDropTarget, nameMass, addPhoto, deletePhoto, item, children }) =>
  connectDropTarget(
    <div className="one-image-wrapper">
      <input
        multiple
        id="exemplar"
        type="file"
        accept="image/*"
        name={nameMass}
        onChange={addPhoto}
        onClick={event => {
          event.target.value = null;
        }}
      />
      {item && item.url ? (
        <OneDragPict
          i={i}
          nameMass={nameMass}
          addPhoto={addPhoto}
          deletePhoto={deletePhoto}
          item={item}
          saveCurrentPictOrder={saveCurrentPictOrder}
        />
      ) : null}
      {children || null}
    </div>
  )
);
